'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRelay = require('react-relay');

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _RelayFragmentPointer = require('react-relay/lib/RelayFragmentPointer');

var _RelayFragmentPointer2 = _interopRequireDefault(_RelayFragmentPointer);

var _reactStaticContainer = require('react-static-container');

var _reactStaticContainer2 = _interopRequireDefault(_reactStaticContainer);

var _checkRelayQueryData = require('react-relay/lib/checkRelayQueryData');

var _checkRelayQueryData2 = _interopRequireDefault(_checkRelayQueryData);

var _flattenSplitRelayQueries = require('react-relay/lib/flattenSplitRelayQueries');

var _flattenSplitRelayQueries2 = _interopRequireDefault(_flattenSplitRelayQueries);

var _invariant = require('fbjs/lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _mapObject = require('fbjs/lib/mapObject');

var _mapObject2 = _interopRequireDefault(_mapObject);

var _splitDeferredRelayQueries = require('react-relay/lib/splitDeferredRelayQueries');

var _splitDeferredRelayQueries2 = _interopRequireDefault(_splitDeferredRelayQueries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IsomorphicRenderer = function (_React$Component) {
  (0, _inherits3.default)(IsomorphicRenderer, _React$Component);

  function IsomorphicRenderer(props, context) {
    (0, _classCallCheck3.default)(this, IsomorphicRenderer);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));

    var garbageCollector = _this.props.relayContext.getStoreData().getGarbageCollector();
    _this.gcHold = garbageCollector && garbageCollector.acquireHold();
    _this.mounted = true;
    _this.pendingRequest = null;
    _this.state = _this._buildInitialState();
    return _this;
  }

  IsomorphicRenderer.prototype._buildInitialState = function _buildInitialState() {
    var _props = this.props;
    var Container = _props.Container;
    var forceFetch = _props.forceFetch;
    var queryConfig = _props.queryConfig;
    var relayContext = _props.relayContext;


    var querySet = _reactRelay2.default.getQueries(Container, queryConfig);

    var _checkCache = checkCache(relayContext, querySet);

    var done = _checkCache.done;
    var ready = _checkCache.ready;


    if (ready) {
      var props = (0, _extends3.default)({}, queryConfig.params, (0, _mapObject2.default)(querySet, function (query) {
        return createFragmentPointerForRoot(relayContext, query);
      }));
      var readyState = {
        aborted: false,
        done: done && !forceFetch,
        error: null,
        mounted: true,
        ready: true,
        stale: !!forceFetch
      };
      return this._buildState(Container, relayContext, queryConfig, readyState, props);
    }

    return this._buildState(null, null, null, null, null);
  };

  IsomorphicRenderer.prototype._buildState = function _buildState(activeContainer, activeContext, activeQueryConfig, readyState, props) {
    var _this2 = this;

    return {
      activeContainer: activeContainer,
      activeContext: activeContext,
      activeQueryConfig: activeQueryConfig,
      readyState: readyState && (0, _extends3.default)({}, readyState, { mounted: true }),
      renderArgs: {
        done: !!readyState && readyState.done,
        error: readyState && readyState.error,
        props: props,
        retry: function retry() {
          return _this2._retry();
        },
        stale: !!readyState && readyState.stale
      }
    };
  };

  IsomorphicRenderer.prototype._buildAndSetState = function _buildAndSetState(activeContainer, activeContext, activeQueryConfig, readyState, props) {
    this.setState(this._buildState(activeContainer, activeContext, activeQueryConfig, readyState, props));
  };

  IsomorphicRenderer.prototype.getChildContext = function getChildContext() {
    var _props2 = this.props;
    var route = _props2.queryConfig;
    var relay = _props2.relayContext;

    return { relay: relay, route: route };
  };

  IsomorphicRenderer.prototype.componentDidMount = function componentDidMount() {
    var readyState = this.state.readyState;

    if (!readyState || !readyState.done) {
      this._runQueries(this.props);
    }
  };

  IsomorphicRenderer.prototype._runQueries = function _runQueries(props) {
    var _this3 = this;

    var Container = props.Container;
    var forceFetch = props.forceFetch;
    var queryConfig = props.queryConfig;
    var relayContext = props.relayContext;

    var querySet = _reactRelay2.default.getQueries(Container, queryConfig);
    var onReadyStateChange = function onReadyStateChange(readyState) {
      if (!_this3.mounted) {
        _this3._handleReadyStateChange((0, _extends3.default)({}, readyState, { mounted: false }));
        return;
      }
      if (request !== _this3.pendingRequest) {
        return;
      }
      var _state$renderArgs = _this3.state.renderArgs;
      var props = _state$renderArgs.props;
      var stale = _state$renderArgs.stale;

      if (props && !readyState.ready) {
        // Do not regress the prepared ready state.
        readyState = (0, _extends3.default)({}, readyState, { ready: true, stale: stale });
      }
      if (readyState.aborted || readyState.done || readyState.error) {
        _this3.pendingRequest = null;
      } else if (props && stale === readyState.stale) {
        // Do not override the prepared state if there is nothing new.
        return;
      }
      if (readyState.ready && !props) {
        props = (0, _extends3.default)({}, queryConfig.params, (0, _mapObject2.default)(querySet, function (query) {
          return createFragmentPointerForRoot(relayContext, query);
        }));
      }
      _this3._buildAndSetState(Container, relayContext, queryConfig, readyState, props);
    };

    if (this.pendingRequest) {
      this.pendingRequest.abort();
    }

    var request = this.pendingRequest = forceFetch ? props.onForceFetch ? props.onForceFetch(querySet, onReadyStateChange) : relayContext.forceFetch(querySet, onReadyStateChange) : props.onPrimeCache ? props.onPrimeCache(querySet, onReadyStateChange) : relayContext.primeCache(querySet, onReadyStateChange);
  };

  IsomorphicRenderer.prototype._runQueriesAndSetState = function _runQueriesAndSetState(props) {
    this._runQueries(props);
    this._buildAndSetState(this.state.activeContainer, this.state.activeContext, this.state.activeQueryConfig, null, null);
  };

  IsomorphicRenderer.prototype._shouldUpdate = function _shouldUpdate() {
    var _state = this.state;
    var activeContainer = _state.activeContainer;
    var activeContext = _state.activeContext;
    var activeQueryConfig = _state.activeQueryConfig;
    var _props3 = this.props;
    var Container = _props3.Container;
    var queryConfig = _props3.queryConfig;
    var relayContext = _props3.relayContext;

    return (!activeContainer || Container === activeContainer) && (!activeContext || relayContext === activeContext) && (!activeQueryConfig || queryConfig === activeQueryConfig);
  };

  IsomorphicRenderer.prototype._retry = function _retry() {
    var readyState = this.state.readyState;

    (0, _invariant2.default)(readyState && readyState.error, 'RelayRenderer: You tried to call `retry`, but the last request did ' + 'not fail. You can only call this when the last request has failed.');
    this._runQueriesAndSetState(this.props);
  };

  IsomorphicRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.Container !== this.props.Container || nextProps.queryConfig !== this.props.queryConfig || nextProps.relayContext !== this.props.relayContext || nextProps.forceFetch && !this.props.forceFetch) {
      if (nextProps.relayContext !== this.props.relayContext) {
        if (this.gcHold) {
          this.gcHold.release();
        }
        var garbageCollector = nextProps.relayContext.getStoreData().getGarbageCollector();
        this.gcHold = garbageCollector && garbageCollector.acquireHold();
      }
      this._runQueriesAndSetState(nextProps);
    }
  };

  IsomorphicRenderer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var readyState = this.state.readyState;

    if (readyState) {
      if (!prevState || readyState !== prevState.readyState) {
        this._handleReadyStateChange(readyState);
      }
    }
  };

  IsomorphicRenderer.prototype._handleReadyStateChange = function _handleReadyStateChange(readyState) {
    var onReadyStateChange = this.props.onReadyStateChange;

    if (onReadyStateChange) {
      onReadyStateChange(readyState);
    }
  };

  IsomorphicRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.pendingRequest) {
      this.pendingRequest.abort();
    }
    if (this.gcHold) {
      this.gcHold.release();
    }
    this.gcHold = null;
    this.mounted = false;
  };

  IsomorphicRenderer.prototype.render = function render() {
    var children = undefined;
    var shouldUpdate = this._shouldUpdate();
    if (shouldUpdate) {
      var _props4 = this.props;
      var Container = _props4.Container;
      var render = _props4.render;
      var renderArgs = this.state.renderArgs;

      if (render) {
        children = render(renderArgs);
      } else if (renderArgs.props) {
        children = _react2.default.createElement(Container, renderArgs.props);
      }
    }
    if (children === undefined) {
      children = null;
      shouldUpdate = false;
    }
    return _react2.default.createElement(
      _reactStaticContainer2.default,
      { shouldUpdate: shouldUpdate },
      children
    );
  };

  return IsomorphicRenderer;
}(_react2.default.Component);

function checkCache(relayContext, querySet) {
  var queuedStore = relayContext.getStoreData().getQueuedStore();

  var done = true;
  var ready = (0, _keys2.default)(querySet).every(function (name) {
    return (0, _flattenSplitRelayQueries2.default)((0, _splitDeferredRelayQueries2.default)(querySet[name])).every(function (query) {
      if (!(0, _checkRelayQueryData2.default)(queuedStore, query)) {
        done = false;
        if (!query.isDeferred()) {
          return false;
        }
      }
      return true;
    });
  });
  return { done: done, ready: ready };
}

function createFragmentPointerForRoot(relayContext, query) {
  return query ? _RelayFragmentPointer2.default.createForRoot(relayContext.getStoreData().getQueuedStore(), query) : null;
}

IsomorphicRenderer.propTypes = {
  Container: _reactRelay2.default.PropTypes.Container,
  forceFetch: _react2.default.PropTypes.bool,
  onReadyStateChange: _react2.default.PropTypes.func,
  queryConfig: _reactRelay2.default.PropTypes.QueryConfig.isRequired,
  relayContext: _reactRelay2.default.PropTypes.Context,
  render: _react2.default.PropTypes.func
};

IsomorphicRenderer.childContextTypes = {
  relay: _reactRelay2.default.PropTypes.Context,
  route: _reactRelay2.default.PropTypes.QueryConfig.isRequired
};

exports.default = IsomorphicRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-relay/lib/IsomorphicRenderer.js
// module id = 1487
// module chunks = 0